import { SET_SELECTED_CATALOG, SET_SELECTED_CATALOGS } from "../actionType";

// Aggiungiamo un console.warn per segnalare che questo reducer è deprecato
if (process.env.NODE_ENV !== 'production') {
    console.warn("DEPRECATION WARNING: catalog reducer è obsoleto, usa catalogues invece");
}

const initialState = {
    selectedCatalog: { id: "all", nome_brand: "All Catalogues" },
    selectedCatalogs: [{ id: "all", nome_brand: "All Catalogues" }]
};

const catalogReducer = (state = initialState, action) => {
    // Gestiamo le azioni SET_SELECTED_CATALOGUES e SET_SELECTED_CATALOGUE
    // dai reducer Catalogues per mantenere sincronizzati gli stati
    if (action.type === 'SET_SELECTED_CATALOGUES' && action.catalogs) {
        return {
            ...state,
            selectedCatalogs: action.catalogs,
            selectedCatalog: action.catalogs.length > 0 ? action.catalogs[0] : initialState.selectedCatalog
        };
    }

    if (action.type === 'SET_SELECTED_CATALOGUE' && action.catalog) {
        return {
            ...state,
            selectedCatalog: action.catalog
        };
    }

    // Gestiamo normalmente le nostre azioni
    switch (action.type) {
        case SET_SELECTED_CATALOG:
            return {
                ...state,
                selectedCatalog: action.catalog || initialState.selectedCatalog,
                selectedCatalogs: action.catalog?.id === "all"
                    ? [initialState.selectedCatalogs[0]]
                    : [action.catalog || initialState.selectedCatalog]
            };
        case SET_SELECTED_CATALOGS:
            return {
                ...state,
                selectedCatalogs: action.catalogs || initialState.selectedCatalogs,
                selectedCatalog: action.catalogs?.length
                    ? action.catalogs[0]
                    : initialState.selectedCatalog
            };
        default:
            return state;
    }
};

export default catalogReducer;